<!--
 * @Author: yuka
 * @Date: 2019-07-31 15:13:51
 * @LastEditors: yuka
 * @LastEditTime: 2019-08-09 16:51:09
 * @Description: 
 -->
<template>
  <div class="m-header-nav-wrapper">
    <div class="m-header-nav">
      <div class="m-nav-wrapper">
        <div
          class="m-nav-item"
          v-for="(item, index) in navList"
          :key="index"
          :class="[{ active: index === activeIndex }]"
          @click="handleRoute(item, index)"
        >
          {{ item.title }}
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'HeaderNav',
  data() {
    return {
      navList: [
        {
          title: '首页',
          path: '/m-index'
        },
        {
          title: '鲸鱼优选',
          path: '/m-perfect-select'
        },
        // {
        //   title: '我要借款',
        //   path: '/m-borrowing'
        // },
        {
          title: '信息披露',
          path: '/m-information'
        },
        {
          title: '党建工作',
          path: '/m-about-us/m-party'
        },
        {
          title: '关于我们',
          path: '/m-about-us'
        }
      ],
      activeIndex: 0
    };
  },
  props: {
    mActiveIndex: {
      type: Number,
      default: 0
    }
  },
  computed: {
    routerPath() {
      return window.location.href.split('#/')[1];
    }
    // activeIndex() {
    //   return this.mActiveIndex;
    // }
  },
  watch: {
    $route(to) {
      if (to.path !== '/m-about-us/m-party/m-list') {
        this.locationRouter(to.path);
      } else {
        // 产品的需求，把党建工作单独拿出来。。。。
        // 路由激活状态写死
        this.activeIndex = 3;
      }
    },
    mActiveIndex(val) {
      this.activeIndex = val;
    }
  },
  created() {
    // this.locationRouter();
    if (this.mActiveIndex === 1) {
      this.activeIndex = 1;
    }
  },
  methods: {
    handleRoute(route, index) {
      this.activeIndex = index;
      this.$router.push(route.path);
    },
    locationRouter(path) {
      this.navList.forEach((item, index) => {
        const tempStr = `/${path.split('/')[1]}`;
        if (item.path === tempStr) {
          this.activeIndex = index;
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
.m-header-nav-wrapper {
  width: 100%;
  position: relative;
  z-index: 1;
  background: #ffffff;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  overflow-y: hidden;
  padding: 0 0.11rem;
  box-sizing: border-box;
  .m-nav-wrapper {
    font-size: 0;
    white-space: nowrap;
    .m-nav-item {
      display: inline-block;
      position: relative;
      font-family: 'PingFangSC-Regular';
      font-family: PingFangSC-Medium;
      font-size: 0.28rem;
      font-weight: normal;
      font-stretch: normal;
      letter-spacing: 0rem;
      line-height: 0.83rem;
      margin: 0 0.19rem;
      color: #333333;
      cursor: pointer;
      white-space: nowrap;
      transition: all 0.2s;
      &.active {
        color: #2c6eff;
        &::after {
          background: #2c6eff;
        }
      }
      &::after {
        content: '';
        width: 100%;
        height: 0.05rem;
        background-color: transparent;
        border-radius: 0.03rem;
        position: absolute;
        bottom: 0rem;
        left: 0;
      }
    }
  }
}
</style>
